import {Component, computed, input} from '@angular/core';

@Component({
  selector: 'lib-bar-minichart',
  imports: [],
  templateUrl: './bar-minichart.component.html',
  styleUrl: './bar-minichart.component.scss',
})
export class BarMinichartComponent {
  readonly maxPositive = input<number, number | undefined>(0,
    {transform: (v) => v && v > 0 ? v : 0},
  );
  readonly maxNegative = input<number, number | undefined>(0,
    {transform: (v) => v && v < 0 ? v : 0},
  );
  readonly value = input.required<number | null | undefined>();

  readonly isAligned = input<boolean>(true);

  readonly #value = computed(() => this.value() || 0);
  readonly #max = computed(() => Math.max(this.#value(), this.maxPositive()));
  readonly #min = computed(() => Math.min(this.#value(), this.maxNegative()));
  readonly #range = computed(() => Math.abs(this.#max()) + Math.abs(this.#min()));

  protected readonly barWidth = computed(() => {
    const v = this.#value();
    if (v === 0) {
      return '0';
    }
    const barValue = Math.abs(v);
    const range = this.#range();

    return (barValue * 100 / range).toFixed(1);
  });

  protected readonly isPositive = computed(() => (this.value() || 0) >= 0);


  protected readonly zeroPosition = computed(() => {
    const v = this.#min();
    if (!v) {
      return 0;
    }
    const negativeValue = Math.abs(v);
    const range = this.#range();
    return (negativeValue * 100 / range).toFixed(2);
  });

  protected readonly barPosition = computed(() => {
    const isPositive = this.isPositive();
    const zeroPosition = this.zeroPosition();
    const barWidth = this.barWidth();
    if (barWidth === '0' || zeroPosition === '0') {
      return '0';
    }
    if (isPositive) {
      return zeroPosition;
    }
    return (Number(zeroPosition) - Number(barWidth)).toFixed(2);
  });
}
